export const mainChainId = "1";
export const mainEthereumChainId = "2";

/*
 * 切换网络提示
 * */
export const chainIdMessage =
  "You are checking the main network data, but your wallet is testing network. Please switch your wallet to main network";
export const testChainIdMessage =
  "You are checking testnet data, but your wallet is on the mainnet. Please switch your wallet to testnet";
export const switchAccountIdMessage =
  "Zetrix account changed. Page will automatically go to home";
export const connectWalletMessage = "Please connect your Zetrix wallet first.";

/*
 * 视图配置参数
 * */
export const viewData = {
  pageSize: 20,
  timerInterval: 10000,
};

/*
 * 编辑器url
 * */
export const ideUrl = "http://192.168.20.111:40072/";

/*
 * 元素size
 * */
export const eleSize = {
  medium: "medium",
  small: "small",
  mini: "mini",
};

/*
 * 节点类型
 * */
export const nodeType = {
  validatorNode: "VALIDATOR_NODE",
  synchronousNode: "SYNCHRONOUS_NODE",
};
